import React from 'react';
import ButtonComponent from 'components/button/buttonComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import {
  AUTH_CREATE_PROVIDER,
  AUTH_LOGIN,
  AUTH_SIGN_UP,
} from 'utilities/routes';
import { Roles } from '../../firebase/interfaces';

export const UnAuthenticatedNavbar: React.FC = () => {
  const { data: locale, loading } = useGetPage({
    locale: 'en',
    pageId: pageIds.NAVBAR_COMPONENT,
  });
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);

  const role = queryParams.get('role') || '';

  const goToSignUp = () => {
    navigate(role === Roles.PROVIDER ? AUTH_CREATE_PROVIDER : AUTH_SIGN_UP);
  };

  if (loading && !locale) return null;

  return (
    <div className="flex flex-row gap-[15px] items-center">
      <ButtonComponent
        paddingX="px-[18.5px] desktop:px-[56px]"
        paddingY="py-[9.5px]"
        testID={'sign-in'}
        type="outlined"
        onClick={() => navigate(AUTH_LOGIN)}
      >
        {locale?.logIn}
      </ButtonComponent>

      <ButtonComponent
        paddingX="px-[18.5px] desktop:px-[56px]"
        paddingY="py-[9.5px]"
        testID={'sign-in'}
        onClick={goToSignUp}
      >
        {locale?.signUp}
      </ButtonComponent>
    </div>
  );
};
